export interface INewApp extends INewVersion {
  appName: string;
}

export interface INewVersion {
  version: string;
}
